import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "rgba(254, 243, 233, 1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 15.0039V17.4239C31 19.0039 30 20.0039 28.42 20.0039H25V13.0139C25 11.9039 25.91 11.0039 27.02 11.0039C28.11 11.0139 29.11 11.4539 29.83 12.1739C30.55 12.9039 31 13.9039 31 15.0039Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 16.0039V30.0039C11 30.8339 11.94 31.3039 12.6 30.8039L14.31 29.5239C14.71 29.2239 15.27 29.2639 15.63 29.6239L17.29 31.2939C17.68 31.6839 18.32 31.6839 18.71 31.2939L20.39 29.6139C20.74 29.2639 21.3 29.2239 21.69 29.5239L23.4 30.8039C24.06 31.2939 25 30.8239 25 30.0039V13.0039C25 11.9039 25.9 11.0039 27 11.0039H16H15C12 11.0039 11 12.7939 11 15.0039V16.0039Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 18.0039H21",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 22.0039H20.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActions;
